import { Contributo } from './models';
import { query } from '../api';
import { ApplicationState } from '..';

export const getContributiInScadenza = (
    state: ApplicationState,
    refreshCache: boolean
): Promise<ReadonlyArray<Contributo>> => {
    const url = 'api/contributi/inscadenza';
    const requestCache: RequestCache = refreshCache ? "reload" : "default";

    return query<ReadonlyArray<Contributo>>(url, state, {}, requestCache);
}